// extracted by mini-css-extract-plugin
export default {"checkmarkDraw":"Checkmark_checkmarkDraw__1fVix","checkmark":"Checkmark_checkmark__w8T40"};